module.exports = __webpack_public_path__ + "static/media/aboutUs.ecd2f6ec.svg";